/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);



var scrollTo = function scrollTo() {
  var document = _global__WEBPACK_IMPORTED_MODULE_0__.jQueryObjects.document,
      screenSelector = '.screen';

  function onClickBtnScrollDown() {
    document.on('click', '.js-scroll-down', function () {
      var _this = $(this),
          nextScreen = _this.closest(screenSelector).next();

      (0,_modules__WEBPACK_IMPORTED_MODULE_1__._scroll)(nextScreen);
    });
  }

  ;
  onClickBtnScrollDown();
};

/* harmony default export */ __webpack_exports__["default"] = (scrollTo);

/***/ }),
/* 2 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "classes": function() { return /* binding */ classes; },
/* harmony export */   "selectors": function() { return /* binding */ selectors; },
/* harmony export */   "jQueryObjects": function() { return /* binding */ jQueryObjects; }
/* harmony export */ });
var classes = {
  activeClass: 'active',
  inActiveClass: 'inactive',
  showClass: 'show',
  hideClass: 'hide',
  bodyClass: 'body'
};
var selectors = {
  btnSelector: '.btn',
  btnCloseSelector: '.js-btn-close',
  sliderSelector: '.slider',
  sliderListSelector: '.js-slider-list'
};
var jQueryObjects = {
  _window: $(window),
  document: $(document),
  btnClose: $(selectors.menuMobileSelector).find(selectors.btnCloseSelector)
};


/***/ }),
/* 3 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_scroll": function() { return /* binding */ _scroll; },
/* harmony export */   "setAttr": function() { return /* binding */ setAttr; }
/* harmony export */ });
function _scroll(elemSelector) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var elem = $(elemSelector);
  $('html, body').animate({
    scrollTop: elem.offset().top - offset
  }, 'slow');
}

;

function setAttr(elemSelector, attr) {
  var elem = $(elemSelector);
  elem.each(function (i, it) {
    $(it).attr(attr, i);
  });
}

;


/***/ }),
/* 4 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);



var slider = function slider() {
  var sliderSelector = _global__WEBPACK_IMPORTED_MODULE_0__.selectors.sliderSelector,
      sliderListSelector = _global__WEBPACK_IMPORTED_MODULE_0__.selectors.sliderListSelector,
      btnCloseSelector = _global__WEBPACK_IMPORTED_MODULE_0__.selectors.btnCloseSelector,
      document = _global__WEBPACK_IMPORTED_MODULE_0__.jQueryObjects.document,
      showClass = _global__WEBPACK_IMPORTED_MODULE_0__.classes.showClass,
      hideClass = _global__WEBPACK_IMPORTED_MODULE_0__.classes.hideClass,
      inActiveClass = _global__WEBPACK_IMPORTED_MODULE_0__.classes.inActiveClass,
      sliderList = $(sliderListSelector),
      mapDotSelector = '.js-map-dot',
      btnPrevSelector = '.js-btn-prev',
      btnNextSelector = '.js-btn-next';

  function onClickBtnArrow(btnSelector, method) {
    var btn = $(btnSelector);
    btn.on('click', function () {
      var _slider = $(this).closest(sliderSelector).find(sliderListSelector);

      _slider.slick(method);
    });
  }

  ;

  function scrollTop() {
    $(sliderSelector).animate({
      scrollTop: 0
    }, 'slow');
  }

  ;

  function bindSliderInfo() {
    var btnInfoSelector = '.js-btn-more',
        shortDescSelector = '.short-desc',
        fullDescSelecotr = '.full-desc';

    function onClickBtnMore() {
      document.on('click', btnInfoSelector, function () {
        var _this = $(this),
            shortDesc = _this.closest(sliderSelector).find(shortDescSelector),
            fullDesc = _this.closest(sliderSelector).find(fullDescSelecotr);

        shortDesc.addClass(hideClass);
        fullDesc.addClass(showClass);
        scrollTop();
      });
    }

    ;

    function onClickBtnClose() {
      document.on('click', btnCloseSelector, function () {
        var _this = $(this),
            shortDesc = _this.closest(sliderSelector).find(shortDescSelector),
            fullDesc = _this.closest(sliderSelector).find(fullDescSelecotr);

        shortDesc.removeClass(hideClass);
        fullDesc.removeClass(showClass);
      });
    }

    ;
    onClickBtnMore();
    onClickBtnClose();
  }

  ;

  function bindSlider() {
    var bodyClass = _global__WEBPACK_IMPORTED_MODULE_0__.classes.bodyClass,
        body = $(bodyClass);

    function showSlider() {
      document.on('click', "".concat(mapDotSelector, ":not('.disable')"), function () {
        var _this = $(this),
            id = _this.data('slider'),
            slider = $("".concat(sliderSelector, "[data-slider='").concat(id, "']"));

        body.addClass(inActiveClass);
        slider.addClass(showClass);
      });
    }

    ;

    function hideSLider() {
      document.on('click', '.js-slider-close', function () {
        var _this = $(this),
            slider = _this.closest(sliderSelector),
            btnClose = slider.find(btnCloseSelector);

        body.removeClass(inActiveClass);
        slider.removeClass(showClass);
        btnClose.click();
      });
    }

    ;
    initSlider();
    showSlider();
    hideSLider();
    onClickBtnArrow(btnNextSelector, 'slickNext');
    onClickBtnArrow(btnPrevSelector, 'slickPrev');
  }

  ;

  function initSlider() {
    var settings = {
      adaptiveHeight: false,
      arrows: false,
      dots: false,
      lazyLoad: 'ondemand',
      speed: 700,
      slidesToShow: 1,
      responsive: [{
        breakpoint: 1280,
        settings: {
          dots: true
        }
      }]
    };
    sliderList.slick(settings);
    $(window).on('orientationchange', function () {
      setTimeout(function () {
        var screenWidth = $(window).width() + 'px'; //alert(screenWidth);

        $('.slick-current').css({
          'width': screenWidth
        });
      }, 200);
    });
  }

  ;

  function initSliderProduct() {
    var slider = $('.js-promo-slider');
    slider.slick({
      adaptiveHeight: false,
      arrows: false,
      dots: true,
      lazyLoad: 'ondemand',
      speed: 700,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000
    });
  }

  ;
  (0,_modules__WEBPACK_IMPORTED_MODULE_1__.setAttr)(sliderSelector, 'data-slider');
  (0,_modules__WEBPACK_IMPORTED_MODULE_1__.setAttr)(".map__img ".concat(mapDotSelector), 'data-slider');
  (0,_modules__WEBPACK_IMPORTED_MODULE_1__.setAttr)(".map__nav ".concat(mapDotSelector), 'data-slider');
  bindSlider();
  bindSliderInfo();
  initSliderProduct();
};

/* harmony default export */ __webpack_exports__["default"] = (slider);

/***/ }),
/* 5 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var share = function share() {
  var share = $('.js-share');

  function initSocialLikes() {
    share.socialLikes({
      counters: false
    });
  }

  ;
  initSocialLikes();
};

/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_scrollTo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _modules_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _modules_share__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);





$(function () {
  (0,_modules_scrollTo__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_modules_slider__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,_modules_share__WEBPACK_IMPORTED_MODULE_2__["default"])();
});
}();
/******/ })()
;